<template
    ><div class="pa-5">
        <v-dialog :value="imageFileDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar color="primary" dark>
                    <v-toolbar-title>{{ active_img.name }}</v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-toolbar-items>
                        <v-btn icon @click="downloadFile(active_img.id)">
                            <v-icon color="white">fal fa-file-download</v-icon>
                        </v-btn>
                        <v-btn dark icon @click="closeDialog">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-container fluid>
                    <v-img :src="active_img.path"></v-img>
                </v-container>
            </v-card>
        </v-dialog>
        <v-list>
            <v-list-item
                v-for="file in activeClient.images"
                :key="file.id"
                style="border-radius: 10px; margin-bottom: 5px; background-color: #F0F0F0"
            >
                <v-list-item-avatar @click="openImageDialog(file)">
                    <v-img :src="file.path" />
                </v-list-item-avatar>
                <v-list-item-content @click="openImageDialog(file)">
                    <v-list-item-title v-text="file.name" />
                    <v-list-item-subtitle v-text="file.date" />
                </v-list-item-content>
                <v-list-item-action>
                    <v-row no-gutters>
                        <v-btn icon @click="downloadFile(file.id)">
                            <v-icon color="blue lighen-1">fal fa-file-download</v-icon>
                        </v-btn>
                    </v-row>
                </v-list-item-action>
            </v-list-item>
            <v-list-item v-if="activeClient && activeClient.images && activeClient.images.length <= 0">
                <v-list-item-content>
                    <v-list-item-title>{{ "No files found" | t }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Store from "@/store";
import settings from "@/settings";

export default {
    name: "image-tab",
    data() {
        return { active_img: [] };
    },
    computed: {
        ...mapState("ClientStore", ["activeClient", "imageFileDialog"])
    },
    methods: {
        openImageDialog(file) {
            this.active_img = file;
            Store.commit("ClientStore/setImageFileDialog", true);
        },
        closeDialog() {
            this.active_img = [];
            Store.commit("ClientStore/setImageFileDialog", false);
        },
        downloadFile(id) {
            let params = "?act=download_file";
            params += "&file_id=" + id;
            window.location.href = settings.api_url + "/file" + params;
        }
    }
};
</script>

<style scoped></style>
